/** The one address users reach support at; every "Contact support" link reads it. */
export const SUPPORT_EMAIL = 'support@agrifulsoftware.com';

/** A `mailto:` link to support. With a reference code, the subject carries it and the body carries the trace, so support can find the failure without asking. */
export const supportMailtoHref = (reference?: { referenceSlug: string; traceId?: string }): string => {
  if (!reference) return `mailto:${SUPPORT_EMAIL}`;
  const subject = `Help with error ${reference.referenceSlug}`;
  const body = [`Reference code: ${reference.referenceSlug}`, reference.traceId && `Trace: ${reference.traceId}`]
    .filter(Boolean)
    .join('\n');
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
